import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../context/useCookieConsent';
import { trackEvent } from '../utils/analytics';

export default function CookieConsentBanner() {
  const { t } = useTranslation();
  const { consentStatus, acceptAnalytics, rejectAnalytics } = useCookieConsent();

  const handleAccept = () => {
    trackEvent('cookie_consent_choice', { choice: 'accepted' });
    acceptAnalytics();
  };

  const handleReject = () => {
    trackEvent('cookie_consent_choice', { choice: 'rejected' });
    rejectAnalytics();
  };

  if (consentStatus !== 'pending') return null;

  return (
    <div
      role="dialog"
      aria-label={t('cookieConsent.message')}
      className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg"
    >
      <div className="container mx-auto max-w-6xl flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-sm text-gray-700 dark:text-gray-200 flex-1">
          {t('cookieConsent.message')}{' '}
          <Link
            to="/cookies"
            className="text-blue-600 dark:text-blue-400 hover:underline font-medium"
          >
            {t('cookieConsent.learnMoreCookiePolicy')}
          </Link>
        </p>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={handleReject}
            className="button__outline"
          >
            {t('cookieConsent.reject')}
          </button>
          <Link
            to="/cookie-settings"
            className="button__outline"
          >
            {t('cookieConsent.settings')}
          </Link>
          <button
            type="button"
            onClick={handleAccept}
            className="button__primary"
          >
            {t('cookieConsent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
